const languageTags: Record<string, string> = {
  de: "de-DE",
  en: "en-GB",
  nl: "nl-NL",
};

function getLanguageTag(language: string): string {
  return languageTags[language] ?? language;
}

function createEventDateFormatter(
  language: string,
  { includeWeekday = false, includeYear = true }: { includeWeekday?: boolean; includeYear?: boolean } = {},
): Intl.DateTimeFormat {
  return new Intl.DateTimeFormat(getLanguageTag(language), {
    day: "numeric",
    month: "short",
    year: includeYear ? "numeric" : undefined,
    weekday: includeWeekday ? "short" : undefined,
  });
}

/** Formats a complete event date according to the active language. */
export function formatEventDate(
  language: string,
  date: Date,
  options?: { includeWeekday?: boolean; includeYear?: boolean },
): string {
  return createEventDateFormatter(language, options).format(date);
}

/** Formats an event date range according to the active language, collapsing shared date parts. */
export function formatEventDateRange(language: string, start: Date, end: Date): string {
  const formattedRange = createEventDateFormatter(language).formatRange(start, end).replaceAll("\u2009", " ");

  if (getLanguageTag(language).startsWith("en-")) {
    return formattedRange.replace(/\s*–\s*/g, " – ");
  }

  return formattedRange;
}
